import Vue from "vue";
import Router from "vue-router";
import Login from "./views/Login.vue";
import Home from "./views/Home.vue";

import store from "./store";


const requireAuthenticated = (to, from, next) => {
  store.dispatch("auth/initialize").then(() => {
    if (!store.getters["auth/isAuthenticated"]) {
      next("/login");
    } else {
      next();
    }
  });
};

const requireUnauthenticated = (to, from, next) => {
  store.dispatch("auth/initialize").then(() => {
    if (store.getters["auth/isAuthenticated"]) {
      next("/");
    } else {
      next();
    }
  });
};

const redirectLogout = (to, from, next) => {
  store.dispatch("auth/logout").then(() => next("/"));
};

Vue.use(Router);

export default new Router({
  saveScrollPosition: true,
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/home',
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      beforeEnter: requireUnauthenticated
    },
    {
      path: "/logout",
      beforeEnter: redirectLogout
    },
    {
      path: "/home",
      name: "home",
      component: Home,
      beforeEnter: requireAuthenticated
    },
    {
      path: "/new/prisoner/:id",
      name: "new",
      component: () => import("./views/new/PrisonerLanding.vue"),
      beforeEnter: requireAuthenticated
    },
    {
      path: "/about",
      name: "about",
      component: () => import("./views/About.vue"),
      beforeEnter: requireAuthenticated
    },
    {
      path: "/admin/search",
      name: "admin_search",
      component: () => import("./views/admin/Search.vue"),
      beforeEnter: requireAuthenticated
    },
    {
      path: "/admin/users",
      name: "admin_users",
      component: () => import("./views/admin/Users.vue"),
      beforeEnter: requireAuthenticated
    },
    {
      path: "/admin/prisoners",
      name: "admin_prisoners",
      component: () => import("./views/admin/Prisoners.vue"),
      beforeEnter: requireAuthenticated
    },
    {
      path: "/admin/institutions",
      name: "admin_institutions",
      component: () => import("./views/admin/Institutions.vue"),
      beforeEnter: requireAuthenticated
    },
    {
      path: "/admin/institutions/:id/history",
      name: "admin_institutions_history",
      component: () => import("./views/admin/InstitutionsHistory.vue"),
      beforeEnter: requireAuthenticated
    },
    {
      path: "/admin/institutions/:id/spracovatelia",
      name: "admin_institutions_spracovatelia",
      component: () => import("./views/admin/SpracovatelDefaultIapsz.vue"),
      beforeEnter: requireAuthenticated
    },
    {
      path: "/admin/statistics/graphs",
      name: "admin_statistics_graphs",
      component: () => import("./views/admin/statistics/Graphs.vue"),
      beforeEnter: requireAuthenticated
    },
    {
      path: "/admin/statistics/graphs_details",
      name: "admin_statistics_graphs_details",
      component: () => import("./views/admin/statistics/GraphsDetails.vue"),
      beforeEnter: requireAuthenticated
    },
    {
      path: "/admin/statistics/tables",
      name: "admin_statistics_tables",
      component: () => import("./views/admin/statistics/Tables.vue"),
      beforeEnter: requireAuthenticated
    },
    {
      path: "/crcra",
      name: "crcra_forms",
      component: () => import("./views/cr_cra/Forms.vue"),
      beforeEnter: requireAuthenticated
    },
    {
      path: "/crcra/:id/history",
      name: "crcra_history",
      component: () => import("./views/cr_cra/History.vue"),
      beforeEnter: requireAuthenticated
    },
    {
      path: "/admin/prisoners/:id/history",
      name: "prisoners_history",
      component: () => import("./views/admin/PrisonersHistory.vue"),
      beforeEnter: requireAuthenticated
    },
    {
      path: "/admin/users/:id/history",
      name: "users_history",
      component: () => import("./views/admin/UsersHistory.vue"),
      beforeEnter: requireAuthenticated
    },
    {
      path: "/crcra/:id",
      name: "crcra",
      component: () => import("./views/cr_cra/CrCra.vue"),
      beforeEnter: requireAuthenticated,
      props: true,

      children: [
        {
          path: "uvod_v1",
          name: "crcra_uvod_v1",
          component: () => import("./views/cr_cra/forms/v1/Uvod.vue"),
        },
        {
          path: "rizikove_faktory_v1",
          name: "crcra_rizikovefaktory_v1",
          component: () => import("./views/cr_cra/forms/v1/RizikoveFaktory.vue")
        },
        {
          path: "penitenciarne_zaobchadzanie_v1",
          name: "crcra_penitenciarnezaobchadzanie_v1",
          component: () =>
            import("./views/cr_cra/forms/v1/PeniterciarneZaobchadzanie.vue")
        },
        {
          path: "psychologicke_vysetrenie_v1",
          name: "crcra_psychologickevysetrenie_v1",
          component: () => import("./views/cr_cra/forms/v1/PsychologickeVysetrenie.vue")
        },
        {
          path: "poznatky_pbs_v1",
          name: "crcra_poznatky_pbs_v1",
          component: () => import("./views/cr_cra/forms/v1/PBS.vue")
        },
        {
          path: "nahodne_overenie_v1",
          name: "crcra_nahodneoverenie_v1",
          component: () => import("./views/cr_cra/forms/v1/NahodneOverenie.vue")
        },
        {
          path: "socialny_kurator_v1",
          name: "crcra_socialnykurator_v1",
          component: () => import("./views/cr_cra/forms/v1/SocialnyKurator.vue")
        },
        {
          path: "zaver_v1",
          name: "crcra_zaver_v1",
          component: () => import("./views/cr_cra/forms/v1/Zaver.vue")
        },
        {
          path: "admin_v1",
          name: "crcra_admin_v1",
          component: () => import("./views/cr_cra/forms/v1/Admin.vue")
        },

        {
          path: "uvod_v2",
          name: "crcra_uvod_v2",
          component: () => import("./views/cr_cra/forms/v2/Uvod.vue"),
        },
        {
          path: "rizikove_faktory_v2",
          name: "crcra_rizikovefaktory_v2",
          component: () => import("./views/cr_cra/forms/v2/RizikoveFaktory.vue")
        },
        {
          path: "penitenciarne_zaobchadzanie_v2",
          name: "crcra_penitenciarnezaobchadzanie_v2",
          component: () =>
            import("./views/cr_cra/forms/v2/PeniterciarneZaobchadzanie.vue")
        },
        {
          path: "psychologicke_vysetrenie_v2",
          name: "crcra_psychologickevysetrenie_v2",
          component: () => import("./views/cr_cra/forms/v2/PsychologickeVysetrenie.vue")
        },
        {
          path: "poznatky_pbs_v2",
          name: "crcra_poznatky_pbs_v2",
          component: () => import("./views/cr_cra/forms/v2/PBS.vue")
        },
        {
          path: "socialny_kurator_v2",
          name: "crcra_socialnykurator_v2",
          component: () => import("./views/cr_cra/forms/v2/SocialnyKurator.vue")
        },
        {
          path: "zaver_v2",
          name: "crcra_zaver_v2",
          component: () => import("./views/cr_cra/forms/v2/Zaver.vue")
        },
        {
          path: "admin_v2",
          name: "crcra_admin_v2",
          component: () => import("./views/cr_cra/forms/v2/Admin.vue")
        }
      ]
    },
    {
      path: "/iapsz",
      name: "iapsz_forms",
      component: () => import("./views/iapsz/Forms.vue"),
      beforeEnter: requireAuthenticated
    },
    {
      path: "/iapsz/:id",
      name: "iapsz",
      component: () => import("./views/iapsz/Iapsz.vue"),
      beforeEnter: requireAuthenticated,
      props: true,

      children: [
        {
          path: "udaje_o_klientovi",
          name: "iapsz_udaje_o_klientovi",
          component: () => import("./views/iapsz/forms/UdajeOKlientovi.vue"),
        },
        {
          path: "rizika_a_dohlad",
          name: "iapsz_rizika_a_dohlad",
          component: () => import("./views/iapsz/forms/RizikaADohlad.vue"),
        },
        {
          path: "swot",
          name: "iapsz_swot",
          component: () => import("./views/iapsz/forms/Swot.vue"),
        },
        {
          path: "potreby_plan",
          name: "iapsz_potreby_plan",
          component: () => import("./views/iapsz/forms/PotrebyPlan.vue"),
        },
        {
          path: "aktualny_stav",
          name: "iapsz_aktualny_stav",
          component: () => import("./views/iapsz/forms/AktualnyStav.vue"),
        },
        {
          path: "dokumenty",
          name: "iapsz_dokumenty",
          component: () => import("./views/iapsz/forms/Dokumenty.vue"),
        },
        {
          path: "prehlad_zmien",
          name: "iapsz_prehlad_zmien",
          component: () => import("./views/iapsz/forms/PrehladZmien.vue"),
        },
        {
          path: "spracovatelia",
          name: "iapsz_spracovatelia",
          component: () => import("./views/iapsz/forms/Spracovatelia.vue"),
        },
        {
          path: "socialne_programy",
          name: "iapsz_socialne_programy",
          component: () => import("./views/iapsz/forms/SocialneProgramy.vue"),
        },
      ]
    },
    {
      path: "/general/zavislosti_pred/",
      name: "general_zavislosti_pred_forms",
      component: () => import("./views/general/FormsZavislostiPred.vue"),
      beforeEnter: requireAuthenticated
    },
    {
      path: "/general/zavislosti_pred/:id",
      name: "general_zavislosti_pred",
      component: () => import("./views/general/forms/ZavislostiPred.vue"),
      beforeEnter: requireAuthenticated
    },
    {
      path: "/general/zavislosti_po/",
      name: "general_zavislosti_po_forms",
      component: () => import("./views/general/FormsZavislostiPo.vue"),
      beforeEnter: requireAuthenticated
    },
    {
      path: "/general/zavislosti_po/:id",
      name: "general_zavislosti_po",
      component: () => import("./views/general/forms/ZavislostiPo.vue"),
      beforeEnter: requireAuthenticated
    },
    {
      path: "/general/skaly_pred/",
      name: "general_skaly_pred_forms",
      component: () => import("./views/general/FormsSkalyPred.vue"),
      beforeEnter: requireAuthenticated
    },
    {
      path: "/general/skaly_pred/:id",
      name: "general_skaly_pred",
      component: () => import("./views/general/forms/SkalyPred.vue"),
      beforeEnter: requireAuthenticated
    },
    {
      path: "/general/skaly_po/",
      name: "general_skaly_po_forms",
      component: () => import("./views/general/FormsSkalyPo.vue"),
      beforeEnter: requireAuthenticated
    },
    {
      path: "/general/skaly_po/:id",
      name: "general_skaly_po",
      component: () => import("./views/general/forms/SkalyPo.vue"),
      beforeEnter: requireAuthenticated
    },
    {
      path: "/general/testy/",
      name: "general_testy_forms",
      component: () => import("./views/general/FormsTesty.vue"),
      beforeEnter: requireAuthenticated
    },
    {
      path: "/general/testy_pred/:id",
      name: "general_testy",
      component: () => import("./views/general/forms/Testy.vue"),
      beforeEnter: requireAuthenticated
    },

    {
      path: "/general/segregovanekomunity_pred/",
      name: "general_segregovanekomunity_pred_forms",
      component: () => import("./views/general/FormsSegregovaneKomunityPred.vue"),
      beforeEnter: requireAuthenticated
    },
    {
      path: "/general/segregovanekomunity_pred/:id",
      name: "general_segregovanekomunity_pred",
      component: () => import("./views/general/forms/SegregovaneKomunityPred.vue"),
      beforeEnter: requireAuthenticated
    },
    {
      path: "/general/segregovanekomunity_po/",
      name: "general_segregovanekomunity_po_forms",
      component: () => import("./views/general/FormsSegregovaneKomunityPo.vue"),
      beforeEnter: requireAuthenticated
    },
    {
      path: "/general/segregovanekomunity_po/:id",
      name: "general_segregovanekomunity_po",
      component: () => import("./views/general/forms/SegregovaneKomunityPo.vue"),
      beforeEnter: requireAuthenticated
    },

    {
      path: "/socialne_podniky/:token",
      name: "socialne_podniky_forms",
      component: () => import("./views/socialne_podniky/Forms.vue"),
    },
    {
      path: "/socialne_podniky/:token/profile",
      name: "socialne_podniky_profile",
      component: () => import("./views/socialne_podniky/UserProfile.vue"),
    },

    // {
    //   path: "/socialne_podniky/profile/",
    //   name: "socialne_podniky_profile_admin",
    //   component: () => import("./views/socialne_podniky/UserProfile.vue"),
    // },

    {
      path: "/socialne_podniky/",
      name: "socialne_podniky_forms_admin",
      component: () => import("./views/socialne_podniky/Forms.vue"),
    },
    {
      path: "/socialne_podniky_users/",
      name: "socialne_podniky_users",
      component: () => import("./views/socialne_podniky/UserList.vue"),
      beforeEnter: requireAuthenticated
    },
  ]
});